import { render } from "./slideMenuItem.vue?vue&type=template&id=2e9c1ffa&scoped=true"
import script from "./slideMenuItem.vue?vue&type=script&lang=js"
export * from "./slideMenuItem.vue?vue&type=script&lang=js"

import "./slideMenuItem.vue?vue&type=style&index=0&id=2e9c1ffa&scoped=true&lang=css"

import exportComponent from "D:\\PDM-小程序\\HSM_PDM\\PDM_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9c1ffa"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QIcon,QCard,QCardSection,QItem});
